import moment, {Moment} from 'moment';

type DateInput = Date | Moment | string | null | undefined;

/**
 * Converts a date-only form value to the API's unambiguous ISO format.
 *
 * Browser date parsing treats strings such as 05/08/2022 as US-style in some
 * environments. Dates entered in VMB are always day-first, so parse those
 * strings explicitly before sending them to the API.
 */
export function toDateOnly(value: DateInput): string | null {
    if (!value) {
        return null;
    }

    let date: Moment;

    if (moment.isMoment(value)) {
        date = value;
    } else if (value instanceof Date) {
        date = moment(value);
    } else {
        date = moment(
            value,
            ['DD/MM/YYYY', 'D/M/YYYY', 'YYYY-MM-DD'],
            'en-GB',
            true
        );
    }

    return date.isValid() ? date.format('YYYY-MM-DD') : null;
}
